import React from 'react';
import { useLabels } from 'wsm-common-data';

const SearchUnavailableHeader = () => {
	const labels = useLabels();
	const searchUnavailableText = labels.get('SEARCH_UNAVAILABLE');

	return (
		<div className="mb-4">
			<h2 className="display-4 text-center font-weight-bold divider-centered-border-bottom divider-primary divider-2 my-4">
				{searchUnavailableText}
			</h2>
		</div>
	);
};

export default SearchUnavailableHeader;
